// Copyright 2024, Imprivata, Inc.  All rights reserved.

// TODO: replace string literals with AuhnMethod enum values
// when it can be imported from the authn module without
// 'react/jsx-runtime' error
export const availableFactorTypes = ['pwd', 'impr-id', 'impr-pin'];

export enum QueryParam {
  AcrValues = 'acrValues',
  ContextType = 'contextType',
  ResourceType = 'resourceType',
  SpRequestId = 'spRequestId',
  RpRequestId = 'rpRequestId',
  ContextId = 'contextId',
  TenantId = 'tenantId',
  Username = 'username',
  LoginHint = 'loginHint',
  CodeChallenge = 'codeChallenge',
  CodeChallengeMethod = 'codeChallengeMethod',
  ShowAddMethod = 'showAddMethod',
  MultiFaceCrop = 'multiFaceCrop',
  ApplicationId = 'applicationId',
  AuthnWorkflowId = 'authnWorkflowId',
  ClientName = 'clientName',
  FitVideoFrame = 'fitVideoFrame',
  ShowVideo = 'showVideo',
  UserCanShowLiveFeed = 'userCanShowLiveFeed',
  // Raw marker searched for as a substring of the full URL. It can arrive
  // url-encoded inside another query param's value (e.g. embedded in `target`)
  // rather than as its own decoded query param, so callers must match it
  // against the raw URL string rather than a parsed URLSearchParams lookup.
  DisableAutoComplete = 'disableAutoComplete',
}
